import axios from 'axios';
import jwtDecode from 'jwt-decode';
import {url} from '../components/MenuCard/CardItem';

const urlLogin = url + '/auth/local';
const urlRegister = url + '/auth/local/register';

const authenticate = (identifier, password) => {
    return axios
        .post(urlLogin, {identifier, password})
        .then((res) => res)
        .then((res) => {
            if (res.status === 200) {
                window.localStorage.setItem('authToken', res.data.jwt);
                window.localStorage.setItem('username', res.data.user.username);
                window.localStorage.setItem('email', res.data.user.email);
                axios.defaults.headers['Authorization'] = 'Bearer' + res.data.jwt;
                window.location = '/';
            } else {
                const emailError = document.querySelector('.email.error');
                const passwordError = document.querySelector('.password.error');

                emailError.innerHTML = 'Erreur dans le mail';
                passwordError.innerHTML = 'Erreur dans le mot de passe';
            }
        });
};

const register = (username, email, password) => {
    return axios
        .post(urlRegister, {username, email, password})
        .then((res) => res)
        .then((res) => {
            // if (res.status === 200) {
            //   window.localStorage.setItem("authToken", res.data.jwt);
            //   window.localStorage.setItem("username", res.data.user.username);
            //   window.localStorage.setItem("email", res.data.user.email);
            //   axios.defaults.headers["Authorization"] = "Bearer" + res.data.jwt;
            //   window.location = "/";
            //   console.log(res.data);
            // } else {
            //   const emailError = document.querySelector(".email.error");
            //   const passwordError = document.querySelector(".password.error");
            //
            //   emailError.innerHTML = "Erreur dans le mail";
            //   passwordError.innerHTML = "Erreur dans le mot de passe";
            // }
        });
};

const isAuthenticated = () => {
    const token = window.localStorage.getItem('authToken');

    if (token) {
        const {exp: expiration} = jwtDecode(token);
        return expiration * 1000 > new Date().getTime();
    } else {
        return false;
    }
};

export const logout = () => {
    window.localStorage.removeItem('authToken');
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('email');
    delete axios.defaults.headers['Authorization'];
};

const userInfos = () => {
    const username = window.localStorage.getItem('username');
    const email = window.localStorage.getItem('email');
    const token = window.localStorage.getItem('authToken');

    if (username && email) {
        let user = {
            username,
            email,
            token,
        };
        return user;
    } else {
        let user = {
            username: 'Pseudo',
            email: 'email',
        };
        return user;
    }
};

const setUp = () => {
    const token = window.localStorage.getItem('authToken');

    if (token) {
        const {exp: expiration} = jwtDecode(token);
        if (expiration * 1000 > new Date().getTime()) {
            axios.defaults.headers['Authorization'] = 'Bearer ' + token;
        }
    }
};

export default {
    authenticate,
    isAuthenticated,
    userInfos,
    logout,
    setUp,
    register,
};
